import { CaseDocumentModel } from "./../../models/case-document";
import { IDocumentModel } from "./../../interfaces/document-model";
import Marionette from "../../../shared/marionette-mustache";
import { PublisherModel } from "../../../desktop/models/publisher";
import { FullTextLinksRelationsView } from "../../../desktop/views/partials/full-text-links-relations";
import { PublisherLinkListsView } from "../../../desktop/views/partials/publisher-link-lists";
import { SourceLinkCollection } from "../../../desktop/collections/source-links";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { CitationLinksModel } from "../../../desktop/models/citation-links";

const template = require<string>("../../../desktop/views/partials/parallel-citations.html");
const lookupLinkTemplate = require<string>("../../../desktop/views/partials/abbreviation-lookup-link.html");

@backboneViewProperties({
    tagName: "div",
    className: "fulltext-sources-container",
    template
})
export class ParallelCitationsView extends Marionette.ItemView<IDocumentModel> {

    constructor(options?: Backbone.ViewOptions<IDocumentModel>) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/parallel-citations.ts